import { SortingActions } from '../constants/sorting/sorting_actions';
import Dispatcher from '../dispatcher';

function setSortingAction(sorting, direction) {
    Dispatcher.handleCatalogSortingAction({
        type: SortingActions.SET_SORTING,
        payload: {
            sorting,
            direction
        }
    });
}

function setSortingOptionsAction(payload) {
    Dispatcher.handleCatalogSortingAction({
        type: SortingActions.SET_SORTING_OPTIONS,
        payload
    });
}

export {
    setSortingAction,
    setSortingOptionsAction
};